import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import PropTypes from "prop-types";
import {sendSlackMessageTracked} from "../../../models/notifications";

const features = [
    {
        name: 'Push to deploy.',
        description:
            'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.',
        icon: CloudArrowUpIcon,
    },
    {
        name: 'SSL certificates.',
        description: 'Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo.',
        icon: LockClosedIcon,
    },
    {
        name: 'Database backups.',
        description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
        icon: ServerIcon,
    },
]

export default function FirefoxSection(props) {
    return (
        <div className="overflow-hidden bg-red-900 py-24 sm:py-32" style={{
            backgroundColor: props.backgroundColor,
            color: props.textColor,
        }}>


            <div className="mx-auto max-w-7xl md:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2 lg:items-start">
                    {props.imageDirection === "left" && imageView()}

                    <div className="px-6 lg:px-0 lg:pt-4 lg:pr-4">
                        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
                            <h2 className="text-base/7 text-indigo-400" style={{
                                color: props.highlightColor,
                            }}>{props.highlightedText}</h2>
                            <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl"
                               style={{
                                   color: props.textColor,
                               }}>
                                {props.title}
                            </p>
                            <p className="mt-6 text-lg/8 text-gray-300" style={{
                                color: props.textColor,
                            }}>
                                {props.blurb}
                            </p>
                        </div>

                        <button
                            hidden={!Boolean(props.ctaText)}
                            type="button"
                            className="custom-font mt-10 flex justify-between items-center rounded-md bg-blue-600 px-3.5 py-2.5 text-white hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                            style={{
                                color: "white",
                                backgroundColor: props.ctaButtonColor,
                            }}
                            onClick={() => {
                                window.open(props.ctaLink, "_blank")
                                sendSlackMessageTracked(`Visitor clicked ${props.ctaText} button`)
                            }}
                        >
                            <div className="mr-4">
                                {
                                    props.ctaText
                                }
                            </div>
                            {
                                props.ctaShouldShowArrow &&
                                <img className="mx-4"
                                     src="https://www.mozilla.org/media/img/firefox/whatsnew/whatsnew142/arrow-right.svg"
                                     width="16" height="16" alt="" aria-hidden="true"/>
                            }
                        </button>
                    </div>

                    {props.imageDirection === "right" && imageView()}


                </div>
            </div>
        </div>
    )

    function imageView() {
        return (

            <div className="sm:px-6 lg:px-0 flex justify-center items-center h-full">

                <div className="mx-auto max-w-2xl sm:mx-0 sm:max-w-none rounded">
                    <img
                        alt="Product screenshot"
                        src={props.imageSrc}
                        width={500}
                        className="max-w-1/2 rounded bg-gray-150"
                    />
                </div>
            </div>
        )
    }
}


FirefoxSection.propTypes = {

    // Color settings
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    highlightColor: PropTypes.string,
    highlightedText: PropTypes.string,

    // Image settings
    imageSrc: PropTypes.string,
    imageAlt: PropTypes.string,
    imageDirection: PropTypes.string,


    // Copywriting content
    title: PropTypes.string,
    blurb: PropTypes.string,

    // CTA
    ctaText: PropTypes.string,
    ctaShouldShowArrow: PropTypes.bool,
    ctaButtonColor: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaAction: PropTypes.func
}

FirefoxSection.defaultProps = {

    // Color settings
    // backgroundColor: "#7F1D1D",
    backgroundColor: "#000",
    textColor: "#FFF",
    highlightColor: "#FFF",

    // Image settings
    imageSrc: "https://www.mozilla.org/media/img/firefox/whatsnew/whatsnew142/relay-hero-1200.png",
    imageAlt: PropTypes.string,
    imageDirection: "right",


    // Copywriting content
    title: "A better workflow",
    blurb: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis iste dolor cupiditate blanditiis ratione.",
    highlightedText: "",

    // CTA
    ctaText: "",
    ctaShouldShowArrow: true,
    // ctaButtonColor: "#003",
    // ctaButtonColor: "#003C6E",
    // ctaButtonColor: "#0079d2",
    ctaButtonColor: "#0360DF",
    ctaLink: PropTypes.string,
    ctaAction: PropTypes.func
}